import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React from "react";
import "./App.css";

import Navbar from "./components/NavBar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import OnePmResult from "./pages/OnePmResult";
import EightPmResult from "./pages/EightPmResult";
import TodayResult from "./pages/TodayResult";
import OldResult from "./pages/OldResult";
import ContactUs from "./pages/ContactUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsCond from "./pages/TermsCond";
import AboutUs from "./pages/AboutUs";
import ErrorPage from "./pages/ErrorPage";

function App() {
  return (
    <Router>
      <div className="app-wrapper">
        <Navbar />
        <main className="flex-grow-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/Home" element={<Home />} />
            <Route path="/onepmresult" element={<OnePmResult />} />
            <Route path="/eightpmresult" element={<EightPmResult />} />
            <Route path="/todayresult" element={<TodayResult />} />
            <Route path="/oldresult" element={<OldResult />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsCond />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
